import React, { useCallback } from 'react';

import { useShouldShowUpsellScreen } from '../../hooks';
import type { CustomizationScreenProps } from '../../navigation/AppNavigation.props';
import { Customization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationScreen = (props: CustomizationScreenProps) => {
  const { navigation, route } = props;

  const { restaurantSlug, productSlug, reorderLineItemId } = route.params ?? {};

  const shouldShowUpsellScreen = useShouldShowUpsellScreen();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (shouldShowUpsellScreen) {
      navigation.replace('UpsellScreen');

      return;
    }

    navigation.replace('Bag', { referrer: 'Menu' });
  }, [navigation, shouldShowUpsellScreen]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Customization
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      onAddLineItemToCart={handleAddLineItemToCart}
      reorderLineItemId={reorderLineItemId}
      isEditProductMode={false}
    />
  );
};
